import React, { useState, useEffect, useContext } from 'react';
import { createMuiTheme, Container, CssBaseline } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from '@material-ui/styles';
import { Checkbox, FormControlLabel} from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import { HttpService } from "../../../apiAuthorization/httpService";
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext';
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";

export default function UserGroupModule(props) {
    const classes = makeStyles(styles);
    const id = props.model.length === 0 ? 0 : props.model.AppModuleGroupId;
    const { theme } = useContext(Theme);
    const [backDrop, setBackDrop] = useState(true);
    const [userGroupModules, setUserGroupModules] = useState([]);
    const [checked, setChecked] = useState([]);
    const [trainingChecked, setTrainingChecked] = useState([]);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);

    const rowStyle = (rowIndex) => {
        return { color: currentTheme.text, background: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const getUserGroupModules = () => {
        HttpService.post('/UserGroup/GetAppModulesNotInGroup', { AppModuleId: id })
        .then((result) => {
            setUserGroupModules(result.data);
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
        });
    };

    const saveUserGroupModule = (item, checked, moduleChecked) => {
        if (moduleChecked)
            item.Checked = checked;
        else
            item.TrainingMode = checked;

        HttpService.post('/UserGroup/SaveAppModuleGroupModule', {
            AppModuleGroupId: id,
            AppModuleId: item.AppModuleId,
            TrainingMode: (item.TrainingMode === null ? false : item.TrainingMode),
            IsDeleted: !item.Checked
        })
        .then((result) => {
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
        });
    };

    useEffect(() => {
        getUserGroupModules();
        // eslint-disable-next-line
    }, []);

    const fetchData = () => {
        return (
            <React.Fragment>
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    <Backdrop className={classes.backdrop} id="groupModuleBackdrop" open={backDrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Container maxWidth="xl" style={{ height: '95%' }} className={props.styles}>
                        <Card color="primary" style={{ height: '100%', background: currentTheme.background }}>
                            <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                                <div className="react-bootstrap-table" style={{ overflowY: "auto", scrollBehavior: "smooth", position: "absolute", top: "15px", bottom: "15px", left: "15px", right: "15px" }}>
                                    <table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, width: "50px" }}>#</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, width: "50px" }}></th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, width: "200px", textAlign: "center" }}>Training</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}>Name</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-capitalize">
                                            {userGroupModules?.map((item, index) => (
                                                <tr key={item.AppModuleId}>                                                        
                                                    <td style={rowStyle(index)}>{index + 1}</td>
                                                    <td style={rowStyle(index)}>
                                                        <FormControlLabel
                                                            label=""
                                                            control={
                                                                <Checkbox
                                                                    name={"chk" + item.AppSettingMenuId}
                                                                    checked={item.Checked}
                                                                    onChange={(e) =>
                                                                        setChecked({ ...checked, [e.target.name]: e.target.checked })
                                                                    }
                                                                    onClick={(e) => saveUserGroupModule(item, e.target.checked, true)}
                                                                    color="primary"
                                                                    style={{ paddingTop: "0px", paddingBottom: "0px" }}
                                                                />
                                                            }
                                                        />
                                                    </td>
                                                    <td style={rowStyle(index)}>
                                                        {item.IsTrainingMode && (
                                                            <FormControlLabel
                                                                label=""
                                                                control={
                                                                    <Checkbox
                                                                        name={"chkTraining" + item.AppSettingMenuId}
                                                                        checked={item.TrainingMode}
                                                                        disabled={!item.Checked}
                                                                        onChange={(e) =>
                                                                            setTrainingChecked({ ...trainingChecked, [e.target.name]: e.target.checked })
                                                                        }
                                                                        onClick={(e) => saveUserGroupModule(item, e.target.checked, false)}
                                                                        color="primary"
                                                                        style={{ paddingTop: "0px", paddingBottom: "0px", paddingLeft: "92px", }}
                                                                    />
                                                                }
                                                            />)}
                                                    </td>
                                                    <td style={rowStyle(index)}>{item.ModuleName}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </CardBody>
                        </Card>
                    </Container>
                </ThemeProvider>
            </React.Fragment>
        );
    }

    let content = fetchData();
    return (
        <>
            {content}
        </>
    );
}
